module.exports = {
    "idPrimary": 1659327,
    "dateCreation": "2019-08-28 13:48:17",
    "dateModification": "2022-02-18 21:59:01",
    "idCompany": "d2dbadb1",
    "idBranch": "32517238",
    "idAgent": "378b485f08",
    "idUser": 1366896,
    "idPublic": "",
    "agentDisplay1": "Ben T Estin",
    "agentDisplay2": "In-Depth Analyzer of the Nocuous",
    "agentDisplay3": "866.977.3627",
    "agentDisplay4": "btestin@xpressdocs.com",
    "agentDisplay5": "www.xpressdocs.com",
    "agentDisplay6": "Line Six",
    "agentDisplay7": "Line Seven",
    "agentDisplay8": "abc.com",
    "agentEmail": "bTestin@xpressdocs.com",
    "agentFax": "",
    "agentIdentifier": "5d66cc7107fac4.91965958",
    "agentInvoiceBranch": 0,
    "agentInvoiceBranchLimit": 0,
    "agentNameFirst": "Benjamin",
    "agentNameLast": "Estin",
    "agentNameMiddle": "T.",
    "agentPhone1": "866-977-3627",
    "agentPhone2": "",
    "agentRandom": "3992",
    "agentActive": 1,
    "agentRegistered": 0,
    "agentWebsite": "",
    "agentDeleted": 0,
    "agentLinkId": "",
    "agentPhoto1": "",
    "agentPhoto2": "",
    "emailOptOut": 0,
    "agentHearAbout": 0,
    "referrer": "",
    "popNotification": "",
    "agentDisplayName": "",
    "agentPhone3": "",
    "licenseNumber": "",
    "flowthruOrigin": "",
    "avalaraUsageType": "",
    "nonProfitStatus": 0,
    "defaultHeadshot": 22398131,
    "defaultHeadshot2": null,
    "meta1": "",
    "meta2": "",
    "sourceIdAgent": "",
    "allowFeedUpdate": 1,
    "source": "1359983",
    "agentAddress1": "",
    "agentAddress2": "",
    "agentCity": "",
    "agentState": "",
    "agentCountry": "",
    "agentZip": "",
    "agentTitle": "",
    "costCenterNum": "",
    "allowAdminsToShare": 1,
    "newYorkSalesTax": 0,
    "imageGallery": {"headshots": [], "logos": []},
    "defaultHeadshotId": 22398131,
    "defaultHeadshot2Id": null,
    "subscriptions": [],
    "activeAddressableOrMailableTemplate": true
};
// module.exports = {
//   "idAgent": "49234d23",
//   "name": "Jane Doe",
//   "description": "Top Producer",
//   "name2": "Joe Doe",
//   "firstName": "Jane",
//   "lastName": "Doe",
//   "firstName2": "Joe",
//   "lastName2": "Doe",
//   "phone": "123-123-1456",
//   "phone2": "321-123-1456",
//   "phone3": "213-123-1456",
//   "office": "OFFICE VAN VLEET & ASSOCIATES, INC.",
//   "email": "jane_doe@Email.com",
//   "facebook": "facebook.com/janedoe88",
//   "website": "www.janedoe88.com",
//   "twitter": "@janedoe88",
//   "bre": "BRE# 00901962",
//   "licenseNumber": "12345678",
//   "headshots":[
//     {
//       "pictureUrl": "http://ds-qa.xpressdocs.com/public/user_pictures_resized/img01.jpg"
//     },
//     {
//       "pictureUrl": "http://ds-qa.xpressdocs.com/public/user_pictures_resized/img02.jpg"
//     },
//     {
//       "pictureUrl": "http://ds-qa.xpressdocs.com/public/user_pictures_resized/img03.jpg"
//     },
//     {
//       "pictureUrl": "http://ds-qa.xpressdocs.com/public/user_pictures_resized/img04.jpg"
//     }
//   ],
//   "subscriptions": []
// }